export default __webpack_public_path__ + "static/media/sticker-16.51298e26.png";